import React, { useState } from 'react';
import {
    Button,
    Checkbox,
    Grid,
    Icon,
    Image,
    Input
} from 'semantic-ui-react';

import CircuitName from './CircuitName';
import UserCard from './Card';
import DropdownFile from './File';
import ClassRooms from './ClassRooms';
import RightSection from './Header/components/RightSection';
import TopBarMobile from './TopBarMobile';

const TopBar = (props) => {
    const {
        // Props from parent
        topBarColor,
        logo_path,
        home_path,
        assignment,
        creator,
        isTeacher,
        propSubmission,
        l,
        show_ai_chat,
        action_name,
        is_mobile,

        // State values
        isSaving,
        is_labLoaded,
        is_public,
        setPublic,
        setShareOpen,
        user,
        userProjects,
        subscription_name,
        title,
        submittedAt,
        submission,
        mark,
        setMark,
        markCaption,
        setMarkCaption,
        zoomValue,
        visible,
        setVisible,
        aiVisible,
        setAiVisible,
        userMenu,
        circuit,

        // Functions
        onSave,
        save,
        showSubmitedAnswerDialog,
        saveMark,
        userMenuChange,
        onZoomMenuChange,

        // Computed values
        show_save_buttons
    } = props;

    // Room the right section needs for the controls that never fold (Sign in or the
    // avatar menu) plus its ☰ menu; it reports this once it has measured them.
    const [rightMinWidth, setRightMinWidth] = useState(0);

    // Render mobile version if on mobile device
    if (is_mobile) {
        return <TopBarMobile {...props} />;
    }

    const circuitTitle = assignment ? `${l.assignment}:${assignment.name}` : title;

    return (
        <Grid stackable={true} id="top-bar" verticalAlign='middle' style={{ backgroundColor: topBarColor || 'var(--sidebar)', minHeight: 70, paddingTop: 5 }}>
            {/* One row that never wraps: the left columns keep their content width (the
                circuit name truncates when they alone run out of room), and the right
                section takes what remains, folding its controls into a ☰ menu to fit. */}
            <style>{`
                #top-bar.ui.grid > .row.top-bar-row {
                    flex-wrap: nowrap !important;
                }
                #top-bar.ui.grid > .row.top-bar-row > .column {
                    width: max-content !important;
                    min-width: max-content;
                    flex: 0 0 auto;
                }
                /* the mark input's fixed width (45px) would otherwise be the column's
                   content width, with "Set Mark" spilling past it */
                #top-bar .top-bar-mark-col .ui.action.input {
                    width: max-content !important;
                }
                #top-bar .top-bar-mark-col .ui.action.input > input {
                    width: 45px;
                    flex: 0 0 45px;
                }
                #top-bar.ui.grid > .row.top-bar-row > .column.top-bar-name-col {
                    width: auto !important;
                    flex: 0 1 auto;
                    min-width: 0 !important;
                    max-width: 25%;
                    overflow: hidden;
                }
                #top-bar.ui.grid > .row.top-bar-row > .column.top-bar-right-col {
                    width: auto !important;
                    flex: 1 1 0;
                }
                #top-bar .top-bar-name-col .ui.feed,
                #top-bar .top-bar-name-col .ui.feed > .event,
                #top-bar .top-bar-name-col .ui.feed > .event > .content,
                #top-bar .top-bar-name-col .ui.feed .summary,
                #top-bar .top-bar-name-col #title_wrapper {
                    min-width: 0;
                    max-width: 100%;
                }
                #top-bar .top-bar-name-col #title_wrapper {
                    display: block;
                    overflow: hidden;
                }
                #top-bar .top-bar-name-col #title_wrapper .title {
                    display: block;
                    max-width: 100%;
                }
                #top-bar .top-bar-name-col .ui.feed .date,
                #top-bar .top-bar-name-col #title_wrapper .title,
                #top-bar .top-bar-name-col .top-bar-answered {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            `}</style>

            <Grid.Row columns={4} className="top-bar-row" style={{ paddingTop: 10, paddingBottom: 2, display: 'flex', alignItems: 'center' }}>

                {/* LOGO */
                    logo_path.indexOf("CircoalreS") != -1 ?
                        <Grid.Column key="logo" width={3} className="middle aligned" style={{ bottom: 0, paddingBottom: 0, maxHeight: 38, maxWidth: 200 }}>
                            <a href={home_path}>
                                <Image src={logo_path} style={{ filter: 'invert()', height: '100%', marginLeft: 6, maxHeight: '38px', float: 'left' }} />
                                <div style={{ display: 'inline', color: 'var(--muted-foreground)', fontSize: 10, verticalAlign: 'middle', marginLeft: '10px', position: 'absolute', top: '50%', transform: 'translateY(-50%)' }}>Powered by DCACLab</div>
                            </a>
                        </Grid.Column>
                        :
                        <Grid.Column key="logo" width={3} className="middle aligned" style={{ bottom: 0, paddingBottom: 0, minWidth: 200, maxHeight: 38, maxWidth: 200 }}>
                            <a href={home_path}>
                                <Image src={logo_path} style={{ width: 200, marginLeft: 6, maxHeight: '38px' }} />
                            </a>
                        </Grid.Column>

                /*end of logo*/}

                {/* Circuit Name */}
                {
                    <>
                        <Grid.Column width={4} className="middle aligned top-bar-name-col" style={{ bottom: 0, paddingBottom: 0 }} title={circuitTitle || undefined}>
                            {/* show for them */}

                            {(circuit || title || action_name === 'lab') &&
                                <>
                                    <CircuitName isSaving={isSaving} assignment={assignment ? assignment : null} circuit={circuit ? circuit : null} title={title} is_public={is_public} has_about={props.has_about} />
                                    {submission != null && submittedAt && <p className="top-bar-answered" style={{ color: 'var(--sidebar-foreground)', marginTop: "revert", fontSize: 11 }}>Answered at: {submittedAt} {submission.mark != null && <span style={{ fontWeight: 'bold', color: 'var(--chart-1)' }}>,mark: {submission.mark}</span>} </p>}
                                </>
                            }
                        </Grid.Column>
                    </>
                }
                {is_labLoaded && circuit && circuit.is_experiment_created && action_name !== 'assignment' &&
                    <Grid.Column width={1} style={{ display: 'flex', alignItems: 'center', padding: '0 2px' }}>
                        <Button compact style={{ background: 'var(--primary)', color: 'var(--primary-foreground)', padding: '0.5em 0.8em', height: '32px', transform: 'translateY(-2px)' }} onClick={() => setShareOpen(true)}
                            size='mini'><Icon name='share' style={{ marginRight: '0.3em' }} />{l.share}</Button>
                    </Grid.Column>
                }
                {/* EMBED MODE: the frame on the circuit page links to the full lab */}
                {props.embed_mode && props.embed_lab_url &&
                    <Grid.Column key="embedLabLink" width={3} className="middle aligned" style={{ bottom: 0, paddingBottom: 0 }}>
                        <a href={props.embed_lab_url} target="_top" style={{ background: 'var(--primary)', color: 'var(--primary-foreground)', padding: '0.6em 1em', borderRadius: 4, fontWeight: 700, whiteSpace: 'nowrap' }}>{l.open_in_lab || 'Open in the lab'}</a>
                    </Grid.Column>
                }
                {/* CREATOR CARD */}
                {is_labLoaded && creator && creator.name != null && (user == null || creator.id != user.id) && !props.embed_mode &&
                    <Grid.Column key="social" width={3} className="middle aligned" style={{ backgroundColor: '0xff0000', bottom: 0, paddingBottom: 0 }}>
                        <UserCard l={l} userProjects={userProjects} creator={creator} />
                    </Grid.Column>
                }

                {/* SAVE BUTTONS */}

                <Grid.Column key="saveButtons" width={(user && (creator && user.id == creator.id) || action_name == 'lab') ? 3 : 1} className="middle aligned" style={{ display: 'flex', alignItems: 'center', padding: '0 4px', zIndex: 20000, position: 'relative' }}>
                    <>
                        {show_save_buttons &&
                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                <Button compact style={{ background: 'var(--chart-4)', color: 'var(--primary-foreground)', padding: '0.5em 0.8em', height: '32px' }} onClick={() => window.open("/lab", '_blank')}
                                    size='mini'>{l.new}</Button>
                                <Button compact style={{ background: 'var(--primary)', color: 'var(--primary-foreground)', padding: '0.5em 0.8em', height: '32px' }}
                                    onClick={() => { onSave(); }} size='mini'>{l.save}</Button>

                                {userProjects != null && userProjects.length > 0 && <DropdownFile
                                    userProjects={userProjects}
                                />}


                                <Checkbox
                                    disabled={subscription_name == 'starter..'}
                                    style={{ color: 'var(--sidebar-foreground)', display: subscription_name == 'starter' ? 'inline-block' : 'inline-block' }}
                                    onChange={(e, data) => {
                                        if (subscription_name == 'starter')
                                            window.thumbs.alert("Private circuit is not available in starter version");
                                        else
                                            setPublic(data.checked)
                                    }}
                                    label={
                                        <label style={{ display: 'flex', alignItems: 'center' }}>
                                            <p style={{ margin: 0, color: 'var(--sidebar-foreground)' }}>{l.public}</p>
                                        </label>
                                    }
                                    checked={subscription_name == 'starter' ? true : is_public}
                                />


                                {user && user.class_rooms.length > 0 &&
                                    <ClassRooms selected_class_room_id={user.selected_class_room_id} class_rooms={user.class_rooms} />
                                }
                            </div>
                        }

                    </>

                </Grid.Column>


                {/*ASSIGNMENT BUTTONS*/}
                {(is_labLoaded && action_name == 'assignment' && user != null && !isTeacher && (submittedAt === null || propSubmission.assignment.settings.resubmit_allowed) && user && creator && submission && submission.user_id == user.id) && !isSaving &&
                    <Grid.Column key="AsignmentSaveButtons" width={2} className="middle aligned" style={{ bottom: 0, paddingBottom: 0 }}>
                        <>
                            <Button color='green'
                                onClick={() => {
                                    window.thumbs.refresh_current_thumb();
                                    setTimeout(() => save(assignment.id), 1);
                                }} size='mini'>{l.save}</Button>
                            {title != undefined &&
                                <Button color='green'
                                    onClick={() => { showSubmitedAnswerDialog(true) }}
                                    size='mini'>{propSubmission.submitted_at == null ? l.submit_answer : (propSubmission.assignment.settings.resubmit_allowed ? l.resubmit_answer : l.submit_answer)}</Button>
                            }
                        </>
                    </Grid.Column>
                }

                {submission != null && submittedAt && isTeacher &&
                    <Grid.Column key="markButton" width={2} className="middle aligned top-bar-mark-col" style={{ bottom: 0, paddingBottom: 0 }}>

                        <Input
                            disabled={isSaving}
                            onKeyPress={(event) => {
                                if (event.key == "Enter") {

                                    setTimeout(() => {
                                        saveMark()
                                    }, 5)

                                } else {
                                    if (!/[0-9]/.test(event.key)) {
                                        event.preventDefault();
                                    }
                                }
                            }}
                            style={{ width: 45 }}
                            size='mini'
                            action={{
                                color: 'orange',
                                labelPosition: 'left',
                                icon: 'pencil',
                                content: markCaption,
                                onClick: () => saveMark()
                            }}
                            actionPosition='left'
                            placeholder=''
                            value={mark}
                            defaultValue='0'
                            onChange={(e, data) => {
                                let v = data.value;
                                if (v > 100) v = 100;
                                setMark(v);
                                setMarkCaption(l.save_mark);
                            }
                            }
                        />

                    </Grid.Column>
                }


                <Grid.Column floated='right' key="login" width={4} className="top-bar-right-col" style={{
                    paddingLeft: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    height: '40px',
                    // the column's own right padding (1rem) comes on top of what its content needs
                    minWidth: rightMinWidth ? `calc(${rightMinWidth}px + 1rem)` : 0,
                    zIndex: 9999
                }}>
                    <RightSection
                        user={user}
                        show_ai_chat={show_ai_chat}
                        userMenu={Array.isArray(userMenu) ? userMenu : []}
                        userMenuChange={userMenuChange}
                        zoomValue={zoomValue}
                        onZoomMenuChange={onZoomMenuChange}
                        visible={visible}
                        setVisible={setVisible}
                        aiVisible={aiVisible}
                        setAiVisible={setAiVisible}
                        action_name={action_name}
                        embed_mode={props.embed_mode}
                        show_help={props.show_help}
                        help_l={props.help_l}
                        is_user_signed_in={props.is_user_signed_in}
                        setTriedToSave={props.setTriedToSave}
                        onMinWidthChange={setRightMinWidth}
                    />
                </Grid.Column>
            </Grid.Row>

        </Grid>
    );
};

export default TopBar;
